<div class="playback-actions-content" [class.disabled]="disabled">

  <!-- Row 1 -->
  <div class="playback-actions">
    <!-- <div class="button-action player" *ngIf="status?.playback?.isPlaylistOpenFile && status?.playback?.isPaused" (click)="goToPrevAndPause()">
    <mat-icon svgIcon="playlist-prev-pause" class="icon next-clip"></mat-icon>
  </div>
  <div class="button-action player" *ngIf="status?.playback?.isPlaylistOpenFile && !status?.playback?.isPaused" (click)="goToPrevAndPlay()">
    <mat-icon svgIcon="playlist-prev-play" class="icon next-clip"></mat-icon>
  </div> -->
  @if ((status?.playback?.openedClips?.length || 0) > 1) {
    <div class="button-action player" (click)="goToPrevClip()">
      <mat-icon svgIcon="forward-next" class="icon rotate next-clip"></mat-icon>
    </div>
  }
  <div class="button-action player" (click)="goToStart()">
    <mat-icon svgIcon="forward-end" class="icon rotate"></mat-icon>
  </div>
  <div class="button-action player" [class.selected]="status?.playback?.isRewind" (click)="rewind()">
    <mat-icon svgIcon="forward" class="icon rotate"></mat-icon>
  </div>
  <div class="button-action player" [class.selected]="status?.playback?.isPlayingReverse" (click)="reverse()">
    <mat-icon svgIcon="play" class="icon rotate"></mat-icon>
  </div>
  <div class="button-action player" [class.selected]="status?.playback?.isPaused" (click)="pause()">
    <mat-icon svgIcon="pause" class="icon"></mat-icon>
  </div>
  <div class="button-action player" [class.selected]="status?.playback?.isPlayingForward" (click)="play()">
    <mat-icon svgIcon="play" class="icon"></mat-icon>
  </div>
  <div class="button-action player" [class.selected]="status?.playback?.isFastForward" (click)="fastForward()">
    <mat-icon svgIcon="forward" class="icon"></mat-icon>
  </div>
  <div class="button-action player" (click)="goToEnd()">
    <mat-icon svgIcon="forward-end" class="icon"></mat-icon>
  </div>
  @if ((status?.playback?.openedClips?.length || 0) > 1) {
    <div class="button-action player" (click)="goToNextClip()">
      <mat-icon svgIcon="forward-next" class="icon next-clip"></mat-icon>
    </div>
  }
  <!-- <div class="button-action player" *ngIf="status?.playback?.isPlaylistOpenFile && status?.playback?.isPaused" (click)="goToNextAndPause()">
  <mat-icon svgIcon="playlist-next-pause" class="icon next-clip"></mat-icon>
</div>
<div class="button-action player" *ngIf="status?.playback?.isPlaylistOpenFile && !status?.playback?.isPaused" (click)="goToNextAndPlay()">
  <mat-icon svgIcon="playlist-next-play" class="icon next-clip"></mat-icon>
</div> -->
</div>

<!-- Row 2 -->
<div class="playback-actions">
  <div class="button-action player" [class.disabled]="!trimPoints.start" (click)="jumpInPoint()">
    <mat-icon svgIcon="forward-out-point" class="icon rotate"></mat-icon>
  </div>
  <div class="button-action player" (click)="jump({offset: -10})">
    -10
  </div>
  <div class="button-action player" (click)="jump({offset: -1})">
    -1
  </div>
  <div class="empty-space"></div>
  <div class="button-action player" (click)="jump({offset: 1})">
    +1
  </div>
  <div class="button-action player" (click)="jump({offset: 10})">
    +10
  </div>
  <div class="button-action player" [class.disabled]="!trimPoints.end" (click)="jumpOutPoint()">
    <mat-icon svgIcon="forward-out-point" class="icon"></mat-icon>
  </div>
  <!-- <div class="empty-space other"></div> -->
</div>

</div>